export interface ContextApi {
  readonly pbx?: PbxContext
  readonly account?: AccountContext
  readonly currentApps?: readonly string[]
  readonly productTrial?: ProductTrial
}

export interface PbxFlags {
  readonly [key: string]: boolean
}

export interface PbxData {
  readonly accountKey: string
  readonly pbxId: string
  readonly pbxUserId?: string
  readonly pbxFlags?: PbxFlags
}

export interface JifApi {
  readonly data: {
    readonly tenants: {
      readonly pbxes: readonly Pbx[]
    }
  }
}

export interface PbxInfoParams {
  readonly externalUserKey: string
  readonly pbxId?: string
  readonly pbxUserId?: string
}

export interface Pbx {
  // eslint-disable-next-line functional/prefer-readonly-type
  id: string
  readonly flags?: { readonly [key: string]: boolean }
  readonly extensions?: readonly Extension[]
  readonly userInfo?: PbxUserInfo
}

export interface PbxUserInfo {
  readonly userId: string
}

export interface Extension {
  readonly id: string
  readonly number: string
}

export interface Principal {
  readonly authorities: readonly unknown[]
  readonly jrn: string
  readonly partnerUsers: readonly unknown[]
  readonly username: string
  readonly users: readonly User[]
}

export interface User {
  readonly jrn: string // This string contains the PBX id
  readonly state: string
  readonly accountKey: string
  readonly pbxName: string
}

export interface ProductTrial {
  readonly free?: boolean
  readonly trial?: boolean
  readonly product?: string
  readonly endDate?: Date
  readonly active?: boolean
}

/**
 * This class contains the current pbx and the functions related to it.
 */
export class PbxContext {
  private _id: string | undefined
  private _userId: string | undefined
  private _flags: PbxFlags | undefined
  constructor(pbxId = '', pbxUserId = '', flags = {}) {
    this.updateId(pbxId)
    this.updateUserId(pbxUserId)
    this.updateFlags(flags)
  }

  public get id(): string | undefined {
    return this._id
  }

  public get userId(): string | undefined {
    return this._userId
  }

  public get flags(): PbxFlags | undefined {
    return this._flags
  }

  public updateId(pbxId: string | undefined) {
    this._id = pbxId
  }

  public updateUserId(pbxUserId: string | undefined) {
    this._userId = pbxUserId
  }

  public updateFlags(flags: PbxFlags | undefined) {
    this._flags = flags
  }
}

export class AccountContext {
  private _key: string | undefined
  constructor(key = '') {
    this.updateAccountKey(key)
  }

  public get key(): string | undefined {
    return this._key
  }

  public updateAccountKey(accountKey: string | undefined) {
    this._key = accountKey
  }
}
